const routes = [
    {
        path: "/tuition/assistance/request",
        component: () => import("../pages/StudentForm.vue"),
        meta: {
            isAuthenticated: true,
            isStudent: true
        },
    },
    {
        path: '/tuition/assistance/requests/:tab?',
        component: () => import('../pages/Index.vue'),
        meta: {
            isAuthenticated: true,
            permission: "tuitionassistancereevaluation_index"
        },

    },
    {
        path: "/tuition/assistance/requests/detail/:id",
        component: () => import("../pages/ShowForm.vue"),
        meta: {
            isAuthenticated: true,
            permission: "tuitionassistancereevaluation_show"
        }
    },
];

export default routes;
